export enum CollaborationEvents {
  ReceiveMessage = 'receiveMessage',
  UpdateMessage = 'updateMessage',
  DeleteMessage = 'deleteMessage',
  AddToCollaboration = 'addToCollaboration',
  ReadCollaboration = 'readCollaboration',
  InitUnreadCollaborations = 'initUnreadCollaborations',
  ThumbnailReady = 'thumbnailReady',
}
